<div class="width-1100">

  <mat-card>

    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>noise_control_off</mat-icon>
        <div>Estatuto</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">

        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">

        <a mat-button (click)="openDialog(null)" matTooltip='Novo Doc' style="width:60px;">
          <mat-icon color='primary'>add_circle_outline</mat-icon>
        </a>
      </div>

    </mat-toolbar>
  </mat-card>

  <mat-card>
    <div class="document-card">

      <div class="file-container">
        <input #filePDF type="file" accept='application/pdf' style="display:none;" (change)="pdfChange($event)" />
        <a mat-button (click)='filePDF.click()' matTooltip='Selecionar PDF'
          style='background-color: whitesmoke;  margin-right: 5px;'>
          <mat-icon class='icon-add'>picture_as_pdf</mat-icon>
        </a>

        <div class="file-info">
          <span *ngIf="pdfDocument$ | async as doc">
            PDF: <a [href]="doc.pdf_url" target="_blank">{{doc.pdf_name}}</a>
          </span>
          <span *ngIf="!pdfDocument$">
            PDF: nenhum arquivo selecionado
          </span>
        </div>

      </div>

      <div class="actions-container">

        <a mat-button (click)='savePDF()' matTooltip='Salvar PDF' style="background-color: whitesmoke;">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </a>

        <a mat-button (click)="openDeletePDF('statute')" matTooltip='Apagar PDF'
          style="background-color: whitesmoke; margin-right: 30px;">
          <mat-icon class='icon-delete'>delete_outline</mat-icon>
        </a>

      </div>

    </div>

  </mat-card>

  <mat-card>

    <!-- TABLE -->
    <mat-table [dataSource]="dataSource" matSort matSortActive="position" matSortDirection='asc'
      matSortDisableClear=true style='height: calc(100vh - 260px); overflow: auto;'>

      <!-- Icon Column -->
      <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon class="icon-dot">noise_control_off</mat-icon>
        </mat-cell>
      </ng-container>
      
      <!-- position Column -->
      <ng-container matColumnDef="position">
        <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.position }} </mat-cell>
      </ng-container>

      <!-- period Column -->
      <ng-container matColumnDef="title">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Título </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.title }} </mat-cell>
      </ng-container>

      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openDialog(element)' matTooltip='Editar' style="background-color: whitesmoke;">
            <mat-icon class='icon-info'>
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- delete Column -->
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='delete(element)' matTooltip='Apagar' style='background-color: whitesmoke;'>
            <mat-icon class='icon-delete' style="font-size:1.5em;">delete_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>


      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>

</div>